global.Reports = {
  baselineCheck: function(event, report_id){
    var id;
    id = $('#report_id').val();
    invited_user = $('#invited_user').val();
    $.ajax({
      dataType: 'script',
      url: '/reports/'+id+'/toggle-baseline'+`?invited_user=${invited_user}`,
      type: 'GET'
    });
  },
  fiscalYearChange: function(event) {
    $('.fiscal-year').val($(event.target).find("option:selected").val())
  },
  clear: function(event) {
    var data;
    id = $('#report_id').val();
    invited_user = $('#invited_user').val();
    data = { invited_user: invited_user, id: id };
    $.ajax({
      dataType: 'script',
      url: '/reports/clear',
      data: data,
      type: 'GET'
    })
  },
  dateChange: function(event) {
    id = $('#report_id').val();
    invited_user = $('#invited_user').val();
    $.ajax({
      dataType: 'script',
      url: '/reports/'+id+'/update_date'+`?invited_user=${invited_user}`,
      data: { report_date: $(event.target).val() },
      type: 'GET'
    })
  }
}

document.addEventListener("turbolinks:load", function() {
  var exampleModal = document.getElementById('exampleModal');
  if (exampleModal != undefined) {
    exampleModal.addEventListener('show.bs.modal', function (event) {
      $('.users-email-input').val([]).trigger('change');
      $('#shareable_type').val([]).trigger('change');
      $('#shareable_id').val([]).trigger('change');
      if ($('.user-list-for-module-access .accordion-collapse.show').length > 0){
        $('.accordion-button').click();
      }
  
      var button = event.relatedTarget;
      
      var report_name = button.getAttribute('data-bs-whatever');
      var shareable_type = button.getAttribute('data-bs-shareable-type');
      var shareable_id = button.getAttribute('data-bs-shareable-id');
      var report_name = button.getAttribute('data-bs-whatever');
  
      var shareable_type_input = $('#shareable_type');
      var shareable_id_input = $('#shareable_id');
  
      shareable_type_input.val(shareable_type);
      shareable_id_input.val(shareable_id);
      var modalTitle = exampleModal.querySelector('.modal-title');
  
      modalTitle.textContent = report_name;
      $('.users-email-input').select2({
        width: '100%',
        tags: true
      });
    });
    var showUserBtn = document.getElementById('heading-list');
    showUserBtn.addEventListener('click', function(){
      var shareable_type_input = $('#shareable_type').val();
      var shareable_id_input = $('#shareable_id').val();
      $.ajax({
        dataType: 'script',
        url: `/fetch_module_access_records?shareable_type=${shareable_type_input}&&shareable_id=${shareable_id_input}`,
        type: 'GET'
      });
    });
  }
});

